import { submitSongRequest } from '../lib/data.js';
import { esc } from '../lib/utils.js';

export async function renderAnketa(view) {
    view.innerHTML = `
        <section class="section narrow">
            <h1 class="page-title">Anketa</h1>
            <p class="page-lead">Jakou píseň chcete od nás slyšet? Napište nám tip — rádi se po něm podíváme.</p>
        </section>
        <section class="section narrow">
            <div class="card" id="request-host">
                <form class="request-form">
                    <label class="request-label" for="song-input">Název písně</label>
                    <input type="text" id="song-input" class="request-input"
                        placeholder="např. píseň nebo interpret" maxlength="200" autocomplete="off">
                    <button type="submit" class="btn btn-primary">Odeslat tip</button>
                    <p class="request-error" hidden></p>
                </form>
            </div>
        </section>
    `;

    const host = view.querySelector('#request-host');
    const form = view.querySelector('.request-form');

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const input = form.querySelector('#song-input');
        const err = form.querySelector('.request-error');
        const song = input.value.trim();

        if (!song) {
            err.textContent = 'Napište prosím název písně.';
            err.hidden = false;
            return;
        }

        const btn = form.querySelector('button');
        btn.disabled = true;
        btn.textContent = 'Odesílám…';
        try {
            await submitSongRequest(song);
            host.innerHTML = `
                <div class="request-done">
                    <h2 class="section-title">Děkujeme!</h2>
                    <p>Tvůj tip „${esc(song)}" jsme zaznamenali.</p>
                    <button class="btn btn-ghost" id="request-again">Poslat další</button>
                </div>`;
            host.querySelector('#request-again').addEventListener('click', () => renderAnketa(view));
        } catch (ex) {
            console.error(ex);
            err.textContent = 'Tip se nepodařilo odeslat. Zkuste to znovu.';
            err.hidden = false;
            btn.disabled = false;
            btn.textContent = 'Odeslat tip';
        }
    });
}
